import React, { useState, useEffect, useRef, createContext } from "react";

const DateContext = createContext();

export const DateConsumer = DateContext.Consumer;

const DateProvider = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  return (
    <DateContext.Provider
      value={{
        isOpen,
        setIsOpen,
        selectedOption,
        toggling,
        onOptionClicked,
      }}
    >
      {props.children}
    </DateContext.Provider>
  );
};

export default DateContext;

export { DateProvider, DateContext };
